import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

interface TeamDeepLinkBannerProps {
  unmatchedAlias: string;
  isTeamListTruncated?: boolean;
}

export const TeamDeepLinkBanner: FC<TeamDeepLinkBannerProps> = ({
  unmatchedAlias,
  isTeamListTruncated,
}) => (
  <MessageBanner type={MessageBannerType.Informational} isDismissible={false}>
    {getString("campaigns.deepLink.unmatched", { alias: unmatchedAlias })}
    {isTeamListTruncated && ` ${getString("campaigns.deepLink.truncated")}`}
  </MessageBanner>
);
